import React from 'react';
import { Button, Typography } from '@mui/material';
import {
  SimSubmissionInterface,
  ArtSubmissionInterface
} from '../../models/FreezePeriodInterface';
import {
  formatSubmissionPeriod,
  getSimPeriodMonth,
  formatArtSubmissionPeriod,
  getArtPeriodMonth
} from '../../helpers/simAccessControl';
import './ArtRequestForm.scss';

interface ArtSimFormRestrictedProps {
  mode?: 'ART' | 'SIM';
  title?: string;
  nextPeriod?: SimSubmissionInterface | ArtSubmissionInterface;
  reason?: string;
}

export default function ArtSimFormRestricted({
  mode = 'SIM',
  nextPeriod
}: ArtSimFormRestrictedProps) {
  const formType = mode === 'SIM' ? 'SIM' : 'ART';

  // Use appropriate helper functions based on mode
  const formatPeriod =
    mode === 'ART'
      ? (period: ArtSubmissionInterface) => formatArtSubmissionPeriod(period)
      : (period: SimSubmissionInterface) => formatSubmissionPeriod(period);

  const getPeriodMonth =
    mode === 'ART'
      ? (period: ArtSubmissionInterface) => getArtPeriodMonth(period)
      : (period: SimSubmissionInterface) => getSimPeriodMonth(period);

  return (
    <div className="art-sim-request-restricted">
      {/* Title
      <Typography variant="h3" className="restricted-main-title">
        {formType} Request Form
      </Typography> */}

      {/* Status and Info Cards Container */}
      <div className="info-cards-container">
        {/* Status Card */}
        <div className="status-card">
          <div className="status-header">OPENING SOON</div>
          <div className="status-content">
            <Typography variant="body2" className="status-label">
              Next submission period:
            </Typography>
            <Typography variant="h4" className="status-value">
              {nextPeriod
                ? `${getPeriodMonth(nextPeriod as any)} ${nextPeriod.sim_year}`
                : 'TBD'}
            </Typography>
          </div>
        </div>

        {/* Submission Period Card */}
        <div className="info-card">
          <Typography variant="body2" className="info-label">
            Submission period:
          </Typography>
          <Typography variant="body1" className="info-value">
            {nextPeriod ? formatPeriod(nextPeriod as any) : 'Pending Schedule'}
          </Typography>
        </div>

        {/* Description Text */}
        <div className="description-text">
          <Typography variant="body1">
            The {formType} Request submission period is currently closed. You
            can only submit {formType} requests during designated submission
            periods.
          </Typography>
        </div>
      </div>

      {/* Return Button */}
      <Button
        onClick={() => {
          window.location.href = '/';
        }}
        className="return-home-button"
        variant="contained"
      >
        Return to Homepage
      </Button>
    </div>
  );
}
